export const LISTING_REQUEST = 'LISTING_REQUEST';
export const REMOVE_NOTIFICATION_REQUEST = 'REMOVE_NOTIFICATION_REQUEST';
export const SAVE_TOKEN_REQUEST = 'SAVE_TOKEN_REQUEST';
export const SAVE_TOKEN_SUCCESS = 'SAVE_TOKEN_SUCCESS';
